import React, { useState } from "react";
import { Box, Card, CardContent, Dialog, DialogContent,  Grid, IconButton } from "@mui/material";
import MUITypography from "../../Components/MUITypography";
import EditIcon from "@mui/icons-material/Edit";
import FormFieldValues from "../../Components/Custom/FormFieldValues";
import UpdateUserRegistration from "./UpdateUserRegistration";
import { checkIsPermissionExist, isEmpty } from "../../Util/UtilHelper";
import SubscribeAndProfilePic from "./SubscribeAndProfilePic";
import StorageFactory from "../../Util/StorageFactory";
import { ACCESS_RESTRICTED_MESSAGE, SESSION_USER_ROLES_PERMISSIONS } from "../../Util/VMConstants";
import NoPermission from "../../Components/NoPermission";

function UpdateUserInfo(props) {

  const [open, setOpen] = useState(false);
  const {userState , loadProfile ,} = props;

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const sessionFactory = new StorageFactory('session');
  const VM_PERMISSIONS = sessionFactory.get(SESSION_USER_ROLES_PERMISSIONS);


  return (
    <Box>

        <SubscribeAndProfilePic userState={userState}/>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          padding: 1,
          flexWrap: "wrap",
        }}
      >
        <MUITypography label="Personal Details" variant='h3' sx={{fontWeight:700,fontSize:'18px'}}  />
        {
        checkIsPermissionExist(VM_PERMISSIONS,'VM019')
          &&
        <IconButton
          aria-label="edit"
          onClick={handleOpen}
          sx={{ width: "auto", alignSelf: "flex-start" }}
        >
          <EditIcon />
        </IconButton>
        }

      </Box>
      {
        checkIsPermissionExist(VM_PERMISSIONS,'VM013')
        ?
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Box sx={{ p: 2 }}>
            <Grid container spacing={5} fullWidth 
            // justifyContent={'space-between'}
            >
              <Grid item xs={12} sm={6} md={6} lg={3} >
                <FormFieldValues title="Name" subtitle={userState.name} />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={3}>
                <FormFieldValues title="Mobile" subtitle={"+"+userState.country_code+" "+userState.mobile_no } />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={3}>
                <FormFieldValues title="Email" subtitle={userState.email} />
              </Grid>
              {
                !isEmpty(userState?.country_data)
                ?  <Grid item xs={12} sm={6} md={6} lg={3}>
                      <FormFieldValues title="Currency" subtitle={userState?.country_data?.currency_code} />
                   </Grid>
                : null
              }
              

            </Grid>
          </Box>
        </CardContent>
      </Card>
      :  <Box sx={{ mt: 4 }}>
            <NoPermission message={ACCESS_RESTRICTED_MESSAGE} />  
        </Box>
      }  

      
      {/* Dialog for UserRegistration Form */}
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
        {/* <DialogTitle>Edit Personal Details</DialogTitle> */}
        <DialogContent>
          <UpdateUserRegistration userState={userState} onClose={handleClose} loadProfile={loadProfile}/>
        </DialogContent>
      </Dialog>

    </Box>
  );
}

export default UpdateUserInfo;
